import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import { addUrlProps, UrlQueryParamTypes } from 'react-url-query';
import { actions } from 'react-redux-form';
import { Loader } from '../../components';
import { loadData, setError } from '../../reducers/tickers';
import { loadTickerData } from '../../data/provider';
import { BT_START, TIMEZONE } from '../../config/constants';

class Container extends Component {
  static propTypes = {
    // URL props are automatically decoded and passed in based on the config
    startingAmount: PropTypes.number,
    startingDate: PropTypes.string,
    stockAllocation: PropTypes.number,
    bitcoinPercentage: PropTypes.number,
    withRebalancing: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    
    let { startingAmount, startingDate, stockAllocation, bitcoinPercentage, withRebalancing } = props;
    let initialInputs = {};

    if (typeof withRebalancing !== "undefined") {
      initialInputs.withRebalancing = withRebalancing;
    }

    if (stockAllocation >= 0 && stockAllocation <= 100) {
      initialInputs.stockAllocation = Math.round(stockAllocation);
    }

    if (bitcoinPercentage >= 0 && bitcoinPercentage <= 100) {
      initialInputs.bitcoinPercentage = Math.round(bitcoinPercentage);
    }

    if (startingAmount > 0) {
      initialInputs.startingAmount = startingAmount;
    }

    if (typeof startingDate !== "undefined") {
      startingDate = moment(startingDate, 'YYYY-MM-DD', TIMEZONE);
      if (startingDate.isValid() && startingDate.isSameOrAfter(BT_START)) {
        initialInputs.startingDate = startingDate;
      }
    }

    props.initializeForm(initialInputs);

    loadTickerData()
      .then(data => props.loadData(data))
      .catch(error => props.setError(error));
  }

  render() {
    return <Loader {...this.props} />
  }
};

const urlPropsQueryConfig = {
  startingAmount: { type: UrlQueryParamTypes.number },
  startingDate: { type: UrlQueryParamTypes.string },
  stockAllocation: { type: UrlQueryParamTypes.number },
  bitcoinPercentage: { type: UrlQueryParamTypes.number },
  withRebalancing: { type: UrlQueryParamTypes.boolean },
};

const mapStateToProps = state => {
  return {
    error: state.tickers.error,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    loadData: (data) => {
      dispatch(loadData(data));
    },
    setError: (error) => {
      dispatch(setError(error));
    },
    initializeForm: (data) => {
      dispatch(actions.merge('input', data));
    }
  }
}

export const LoaderContainer = addUrlProps({ urlPropsQueryConfig })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Container)
);


// WEBPACK FOOTER //
// ./src/containers/Loader/LoaderContainer.js